import { render, staticRenderFns } from "./dp-layout.vue?vue&type=template&id=4481d9ed&scoped=true"
import script from "./dp-layout.vue?vue&type=script&lang=js"
export * from "./dp-layout.vue?vue&type=script&lang=js"
import style0 from "./dp-layout.vue?vue&type=style&index=0&id=4481d9ed&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4481d9ed",
  null
  
)

export default component.exports